import reduxCrud from 'redux-crud';

const customFieldsReducers = reduxCrud.Map.reducersFor('customFields', {
  key: 'id',
});

export default customFieldsReducers;
